module.exports = __webpack_public_path__ + "img/full5-min.abf5f1fb.png";